<div class="d-flex m-phone-wrapper {{customClass}}">

    <div class="input-wrapper number-input-wrapper">
      <input class="app-input" [formControl]="inputControl" placeholder=" " onchange="setAttribute('value', this.value)" maxlength="7"
        type="tel" NumbersOnly
        [ngClass]="[(inputControl.invalid && inputControl.dirty) ? 'app-error-border': '', (inputControl.invalid && submitted) ? 'app-error-border': '']"
        (input)="onChangeNumber($event.target.value)" [value]="currentNumber" required [attr.aria-label]="ariaLabel">
      <label class="label">{{ 'HELP_DIALOG.PHONE_NUMBER_PC' | translate }}</label>
    </div>

  <div class="prefix-wrapper">
    <app-dplist-new [valueArr]='prefixes' [(ngModel)]="currentPre" (change)="onPreChange($event)" [asyncData]="false" [atrrAriaLabel]="ariaLabelPre">
    </app-dplist-new>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/phone-number/phone-number.component.html